import React from 'react'
import MeetingExample from '../../../assets/signin-meeting-example.png'
import { CheckMark } from './checkMark'
import { Testimonial } from '../../utils/testimonial'

export function Sidebar() {
  return (
    <div className="max-w-md mx-auto">
      <img src={MeetingExample} alt="meeting-example" className="w-full max-w-sm h-auto mx-auto mb-6" />
      <div className="px-4 mb-8">
        <div className="space-y-3">
          {[
            'Perfect user research on every call',
            'Miss nothing, no matter how fast it goes by',
            'Never feel overwhelmed',
          ].map((text, index) => (
            <CheckMark text={text} key={index} />
          ))}
        </div>
      </div>
      <div className="px-4 pb-8">
        <Testimonial />
      </div>
    </div>
  )
}
